import React from "react";
import video_icon from "../images/video_icon.png";
import { Link } from "react-router-dom";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import ClassStatus from "./classStatus";
import VideoPlayer from "../videos/VideoPlayer";

export default function ClassOrder(props) {
  const trips = props.trips.length;

  function getVideosList(uuid) {
    var trip = props.videos_list.find((v) => v.uuid == uuid);
    if (trip) {
      var videos = trip.videos;
      return videos;
    }
    return [];
  }

  function getFaultTime(
    time_faults,
    faults,
    time,
    round_no,
    placing,
    is_result
  ) {
    var JOQualified = false;

    if (props.jumper_table_info && props.jumper_table_info.hasJO) {
      if (time_faults) {
        JOQualified = false;
      } else {
        JOQualified = true;
      }
    }

    var hasPlacing = placing > 0 && placing != 100000;
    var hasJOScore = hasPlacing && JOQualified;

    var total_faults = time_faults + faults;
    if (time > 0) {
      var time_string = time.toString();
      if (props.jumper_table_info && props.jumper_table_info.fei_rule) {
        time = time_string.slice(0, time_string.indexOf(".") + 3);
      } else {
        time = time_string.slice(0, time_string.indexOf(".") + 4);
      }
      return total_faults + " | " + time;
    } else if (is_result) {
      if ((round_no == 1 && hasPlacing) || (round_no == 2 && hasJOScore)) {
        return "N/A";
      } else {
        return " - ";
      }
    } else {
      return " - ";
    }
  }

  function getTeamImagePath(TAbbr, TType, is_thumbnail) {
    var path = "";
    if (TType == "") {
      return path;
    }

    path = "http://cdn.showgroundslive.com/Team_Scoring_Logos/";

    //Check team type
    if (TType == "Country") {
      path += "Countries";
    } else {
      path += "Organizations";
    }

    //Check image type to return
    if (is_thumbnail) {
      path += "/Thumbnails";
    } else {
      path += "/Large";
    }

    path += "/" + TAbbr + ".png";

    return path;
  }

  return (
    <div>
      <ClassStatus
        id='Order'
        class_details={props.class_details}
        related_data={props.related_data}
        trips={trips}
      />
      {props.class_details.order_of_go_set == 1 ? (
        <div class='div-responsive'>
          <table class='table table-striped'>
            <thead class='classes-header'>
              <tr class='sgl-primary-header'>
                <th class='center-align' nowrap='nowrap' style={{verticalAlign: "middle"}}>
                  Order
                </th>
                {props.related_data.is_videos_enabled == true && (
                  <th nowrap='nowrap' style={{verticalAlign: "middle"}}></th>
                )}
                <th nowrap='nowrap' style={{verticalAlign: "middle"}}>Horse</th>
                <th nowrap='nowrap' style={{verticalAlign: "middle"}}>Rider</th>
                {props.class_details.class_type == "Jumpers" && (
                  <th nowrap='nowrap'>
                    Round 1<br />
                    F&nbsp;|&nbsp;T
                  </th>
                )}
                {props.class_details.class_type == "Jumpers" && (
                  <th nowrap='nowrap'>
                    Jump Off
                    <br />
                    F&nbsp;|&nbsp;T
                  </th>
                )}
                {(props.class_details.class_type == "Hunters" ||
                  props.class_details.class_type == "Equitation") &&
                  props.related_data.score_fields.map((f, index) => {
                    return (
                      <th class='center-align' nowrap='nowrap'>
                        S{f}
                      </th>
                    );
                  })}
                {(props.class_details.class_type == "Hunters" ||
                  props.class_details.class_type == "Equitation") && (
                  <th class='center-align' nowrap='nowrap'>
                    Score
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {
                (props.classGroupOrderOfGo.length == 0 ? props.trips.sort((a, b) => (a.order_of_go > b.order_of_go ? 1 : -1)) : props.classGroupOrderOfGo)
                .map((data, index) => {
                  return (
                    <tr
                      className={
                        data.scratch_trip ? "strike_out" : "" + " sgl-anchor"
                      }>
                      <td class='center-align'>
                        <a>
                          {data.order_of_go < 100000 ? (index + 1) : "-"}
                        </a>
                      </td>
                      {props.related_data.is_videos_enabled == true && (
                        <td>
                          <a>
                            {getVideosList(data.entryxclasses_uuid).length >
                            0 ? (
                              <Popup
                                trigger={
                                  <img src={video_icon} class='video-icon' />
                                }
                                on='hover'
                                position='right center'>
                                <div>
                                  <ul class='popup-ul'>
                                    {getVideosList(data.entryxclasses_uuid).map(
                                      (data, index) => {
                                        return (
                                          <li class='class_list_li'>
                                            <a
                                              onClick={props.playVideo(
                                                data.sgl_id
                                              )}>
                                              {data.class_number} -{" "}
                                              {data.class_name}
                                              {props.getVideoTitle(data)}
                                            </a>
                                          </li>
                                        );
                                      }
                                    )}
                                  </ul>
                                </div>
                              </Popup>
                            ) : (
                              ""
                            )}
                          </a>
                        </td>
                      )}
                      {data.scratch_trip ? (
                        <td>
                          <a>
                            {data.number} - {data.horse}
                          </a>
                        </td>
                      ) : (
                        <td>
                          <Link
                            to={
                              "/entries/detail?eid=" +
                              data.entry_id +
                              "&sid=" +
                              props.current_show
                            }>
                            {data.number} - {data.horse}
                          </Link>
                        </td>
                      )}
                      {data.scratch_trip ? (
                        <td>
                          <Link
                            to={
                              "/people/detail?pid=" +
                              data.rider_id +
                              "&sid=" +
                              props.current_show
                            }>
                          { ( (data?.team_id>0 && data.team_name) || props.class_details?.is_team_event) ?
                          <>
                          <div className='rider_div scratch_trip'>
                            <div>
                                <img
                                  src={getTeamImagePath(data.team_abbr,data.team_type,false)}
                                  className='rider_flag_inline_image with_wrapping_text'
                                  onError={(e)=>{e.target.style.display = "none";} } 
                                />
                            </div>
                            <div>
                              {data.rider_name} 
                              { (data?.team_id>0 && data.team_name) ?
                                <div className="rider_team_name">{data.team_name}</div>
                              : 
                                null
                              }
                            </div>
                          </div>
                          </>
                          :
                            <>
                            <img
                              src={
                                props.flag_img_dir[
                                  (data.competing_country
                                    ? data.competing_country
                                    : "USA") + ".png"
                                ]
                              }
                              class='rider_flag_inline_image with_wrapping_text'
                            />
                            {data.rider_name}
                          </>
                          }
                          </Link>
                        </td>
                      ) : (
                        <td>
                          <Link
                            to={
                              "/people/detail?pid=" +
                              data.rider_id +
                              "&sid=" +
                              props.current_show
                            }>
                            { ( (data?.team_id>0 && data.team_name) || props.class_details?.is_team_event) ?
                            <div className="rider_div">
                              <div>
                                <img
                                  src={getTeamImagePath(data.team_abbr,data.team_type,false)}
                                  className='rider_flag_inline_image with_wrapping_text'
                                  onError={(e)=>{e.target.style.display = "none";} } 
                                />
                              </div>
                              <div>
                                {data.rider_name} 
                                { (data?.team_id>0 && data.team_name) ?
                                  <div className="rider_team_name">{data.team_name}</div>
                                : 
                                  null
                                }
                              </div>
                            </div>
                            :
                            <>
                            <img
                              src={
                                props.flag_img_dir[
                                  (data.competing_country
                                    ? data.competing_country
                                    : "USA") + ".png"
                                ]
                              }
                              class='rider_flag_inline_image with_wrapping_text'
                            />
                            {data.rider_name}
                            </>
                            }
                          </Link>
                        </td>
                      )}
                      {props.class_details.class_type == "Jumpers" && (
                        <td>
                          <a>
                            {data.disqualify_status_one != ""
                              ? data.disqualify_status_one
                              : getFaultTime(
                                  data.time_fault_one,
                                  data.faults_one,
                                  data.time_one,
                                  1,
                                  data.placing,
                                  false
                                )}
                          </a>
                        </td>
                      )}
                      {props.class_details.class_type == "Jumpers" && (
                        <td>
                          <a>
                            {data.disqualify_status_two != ""
                              ? data.disqualify_status_two
                              : getFaultTime(
                                  data.time_fault_two,
                                  data.faults_two,
                                  data.time_two,
                                  2,
                                  data.placing,
                                  false
                                )}
                          </a>
                        </td>
                      )}
                      {(props.class_details.class_type != "Jumpers") &&
                      props.related_data.score_fields.map((f, index) => {
                        if (data.disqualify_status_one && f == "1") {
                          return (
                            <td className='center-align'>
                              <a>{data.disqualify_status_one}</a>
                            </td>
                          );
                        } else if (data.disqualify_status_two && f == "2" && props.related_data.hunter_type.indexOf("Hunter Derby") >= 0) {
                          return (
                            <td className='center-align'>
                              <a>{data.disqualify_status_two}</a>
                            </td>
                          );
                        } else {
                          return (
                            <td className='center-align'>
                              <a>{data["score" + f]}</a>
                            </td>
                          );
                        }
                    })}
                    {(props.class_details.class_type != "Jumpers") && (
                      <td className='center-align'>
                        {(data.disqualify_status_one) ?
                          <a>{data.disqualify_status_one}</a>
                          :
                          <a>{data.score}</a>
                        }
                      </td>
                    )}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      ) : (
        <div>Order of Go not yet set.</div>
      )}
      {/* <div>
        {props.playing_video && (
          <VideoPlayer
            is_open_play_video_modal={props.is_open_play_video_modal}
            is_open_do_subscription_modal={props.is_open_do_subscription_modal}
            is_download_subscription={false}
            video_to_play={props.video_to_play}
            is_admin={props.is_admin}
            closeModal={props.closeModal}
            closeSubscriptionModal={props.closeSubscriptionModal}
            playing_preview={false}
            play_video_path={props.video_to_play.video_url}
            playVideoAfterSubscribe={props.playVideoAfterSubscribe}
            VideoSubscriptionElement={props.VideoSubscriptionElement}
            ref={props.VideoPlayerElement}
          />
        )}
      </div> */}
    </div>
  );
}
